import ListJob from  '@/components/Job/ListJob'
import Job from  '@/components/Job/Job'
import Bpe from '@/components/Job/Bpe/Bpe'
import EditJob from  '@/components/Job/EditJob/EditJob'
import JobInvoice from  '@/components/Job/Invoice/ListJobInvoice'

export default [
    {
        path: '/job/:pageCode',
        name: 'job',
        props: true,
        component: ListJob
    },
    {
      path: '/job/create/:branchCode',
      name: 'create-job',
      props: true,
      component: Job
    },
    {
      path: '/job/edit/:jobId',
      name: 'edit-job',
      props: true,
      component: EditJob
    },
    {
      path: '/job/bpe',
      name: 'create-bpe',
      component: Bpe
    },
    {
      path: '/job/invoice/:pageCode',
      name: 'job-invoice',
      props: true,
      component: JobInvoice
    },
    {
      path: '/job/controller/:pageCode',
      name: 'job-controller',
      props: true,
      component: ListJob
    },
    {
      path: '/job/parts/:pageCode',
      name: 'job-parts',
      props: true,
      component: ListJob
    },
    {
      path: '/job/consumable/:pageCode',
      name: 'job-consumable',
      props: true,
      component: ListJob
    },
    {
      path: '/job/image/:pageCode',
      name: 'job-image',
      props: true,
      component: ListJob
    }
]